module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "nav"
    }
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "subdomain_nav_wrapper"
  }, [_c('div', {
    staticClass: "nav_container"
  }, [_c('ul', {
    staticClass: "subdomain_nav_contents"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "link_contents"
  }, _vm._l((_vm.subdomainList), function(subdomainLink) {
    return _c('li', [_c('app-link', {
      staticClass: "subdomain_link",
      attrs: {
        "link": subdomainLink,
        "homeUrl": _vm.homeUrl
      }
    })], 1)
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "main_nav_wrapper"
  }, [_c('div', {
    staticClass: "nav_container"
  }, [_c('div', {
    staticClass: "main_nav_contents"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('button', {
    staticClass: "nav_button",
    on: {
      "click": _vm.handleBurgerClick
    }
  }, [(!_vm.mobileMenu) ? _c('img', {
    attrs: {
      "src": require("./../assets/img/nav-mobile.svg"),
      "alt": "Mobile menu open"
    }
  }) : _c('img', {
    attrs: {
      "src": require("./../assets/img/x-icon.svg"),
      "alt": "Mobile menu close"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav_list",
    class: {
      nav_list_open: _vm.mobileMenu,
        nav_list_submenu_open: !!_vm.activeName,
    }
  }, [_vm._l((_vm.navigationList), function(item) {
    return _c('li', {
      key: item.name,
      staticClass: "nav_url",
      class: {
        nav_url_active: item.name === _vm.activeName,
          nav_url_parent: !!item.links
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.handleItemClick(item.name)
        }
      }
    }, [(item.url) ? _c('app-link', {
      staticClass: "nav_url_name",
      attrs: {
        "link": item,
        "homeUrl": _vm.homeUrl
      }
    }) : _vm._e(), _vm._v(" "), (!item.url) ? _c('span', {
      staticClass: "nav_url_name",
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.handleItemClick(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (item.links && item.name === _vm.activeName) ? _c('div', {
      staticClass: "dropdown_small",
      class: {
        dropdown_small_open: item.name === _vm.activeNameDelay,
      }
    }, [_c('button', {
      staticClass: "nav_sub_name",
      on: {
        "click": function($event) {
          _vm.handleItemClick('')
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('ul', {
      staticClass: "nav_sub",
      class: {
        nav_sub_support: item.name === 'Support',
      }
    }, _vm._l((item.links), function(subitem) {
      return _c('navigation-sub', {
        key: subitem.name,
        attrs: {
          "subitem": subitem,
          "homeUrl": _vm.homeUrl
        }
      })
    })), _vm._v(" "), (item.text) ? _c('div', {
      staticClass: "nav_text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _vm._e()]) : _vm._e()], 1)
  }), _vm._v(" "), _c('a', {
    staticClass: "nav_contact_button",
    attrs: {
      "href": "https://opentrons.com/contact",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n              CONTACT SALES\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "demo_button",
    attrs: {
      "href": "https://opentrons.com/demo",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n              SCHEDULE DEMO\n            ")])], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://opentrons.com/",
      "data-gtm-category": "p-header",
      "data-gtm-label": "logo",
      "data-gtm-action": "click"
    }
  }, [_c('img', {
    staticClass: "nav_logo",
    attrs: {
      "src": "https://s3.amazonaws.com/opentrons-images/website/ot_logo_full.png",
      "alt": "Opentrons Home"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40aa51d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 238
// module chunks = 2